export function removePTags(inputString) {
  // Vérifie si une chaîne valide a été transmise
  if (typeof inputString !== 'string') {
    throw new Error("Le paramètre doit être une chaîne de caractères.");
  }
  // Remplace les balises <p> ouvertes et fermées dans le texte
  return inputString.replace(/<\/?p>/g, '');
}

